import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { EmailChannelPolicy } from '../models/email-channel-policy.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface EmailChannelPolicyDrawerOptions {
  /** Definido → modo edición. */
  policyId?: number;
  /**
   * Política a editar. El endpoint de admin solo expone list() (sin getById),
   * por eso la lista pasa el objeto completo al abrir el drawer en edición.
   */
  policy?: EmailChannelPolicy;
}

@Injectable({ providedIn: 'root' })
export class EmailChannelPolicyDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: EmailChannelPolicyDrawerOptions }>({
    isOpen: false,
    options: {},
  });

  private readonly saved$$ = new Subject<EmailChannelPolicy>();

  readonly state = this.state$.asObservable();
  readonly saved$ = this.saved$$.asObservable();

  open(options: EmailChannelPolicyDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }

  notifySaved(policy: EmailChannelPolicy): void {
    this.saved$$.next(policy);
  }
}
